<template>
  <v-container fluid class="pa-0 ma-0">
    <v-app id="inspire">
      <v-card class="elevation-0">
        <v-img class="white--text" max-height="590px" src="@/assets/aboutusbg.jpg">
          <v-container>
            <div class="mt-16 mx-lg-8 pt-lg-16">
              <v-row no-gutters>
                <v-col cols="12" sm="4" md="5">
                  <v-card class="ma-2 mt-16">
                    <div class="waviy">
                      <h1 class="clrbluetext font-weight-bold fd50SS">About US</h1>
                      <h2 class="linespht spans clrbluetext font-weight-bold">
                        Discover. Discuss. Develop.
                      </h2>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="8" md="7">
                  <v-card
                    class="pa-2 ma-2 d-flex align-center justify-center htlargef mt-sm-16 mt-xl-8"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/dgxg.png"
                      class="fill-height zoom-effect"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-img>
      </v-card>

      <v-card class="elevation-0 bgpanel">
        <v-container>
          <div>
            <v-row no-gutters>
              <!-- LEFT COLUMN -->
              <v-col cols="12">
                <!-- observer wrapper for mobile heading -->
                <div ref="leftHeadingMobile" class="observer">
                  <h1
                    class="rainbow-text text-center fontfamMon font-weight-bold linespht display-1 anim-item fade-up delay-100"
                    style="font-size: clamp(22px, 4vw, 32px) !important"
                  >
                    Welcome to Sactin
                  </h1>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="mx-lg-8">
            <v-row no-gutters>
              <!-- LEFT COLUMN -->
              <v-col cols="12" sm="4" lg="3">
                <div ref="imageCard2" class="observer">
                  <v-card
                    class="px-2 mx-2 pb-2 mb-2 d-none d-sm-block align-center justify-center htlargef2 anim-item zoom-in delay-200"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/companystory.jpg"
                      class="fill-height"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </div>
              </v-col>

              <!-- RIGHT COLUMN -->
              <v-col cols="12" sm="8" lg="9">
                <v-card class="ma-2">
                  <div ref="paragraph" class="observer">
                    <p
                      class="mt-6 mt-lg-14 text-justify linespht1 black--text body-1 anim-item fade-left delay-300"
                    >
                      We, Sactin is a growing IT Company with a vision of achieving new
                      innovative heights in the field of Software Development. We are a
                      team of experienced software experts who are dedicated to deliver
                      quality projects. We promise that the projects that are designed and
                      developed by us will be the best with industry standards and will be
                      built using high end technologies and will be delivered ahead of
                      committed, scheduled time. <br />
                      We go through some strict processes as we weigh up everything from
                      design and features, interface and price. We do research and
                      development of innovative, customized software products which create
                      challenges to our knowledge base.We are very happy to provide our
                      service to an esteemed client like you and here-by we assure you the
                      best from us. We also providing e-learning contents and hardwares
                      that enhancing learning.
                    </p>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <!-- observer wrapper for image card -->
              <v-col>
                <div ref="imageCard1" class="observer">
                  <v-card
                    class="px-12 mx-2 pb-2 mb-2 d-block d-sm-none align-center justify-center htlargef2 anim-item zoom-in delay-200"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/companystory.jpg"
                      class="fill-height"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
      <!-- end sec part -->

      <!-- start 3rd section -->
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Popular Products
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <!-- start 3rd section -->

      <v-container fluid class="pa-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <v-row class="mrtopmobile" justify="center">
              <!-- Start card loop -->
              <v-col
                v-for="(card, index) in cards"
                :key="index"
                cols="12"
                sm="6"
                lg="3"
                xl="3"
                class="d-flex justify-center"
              >
                <div class="a-box">
                  <div class="img-container"></div>
                  <div class="text-container d-flex flex-column justify-space-between">
                    <v-card>
                      <v-img
                        :src="getImage(card.image)"
                        height="200px"
                        class="brradius"
                      ></v-img>

                      <v-card-title class="pa-3">{{ card.title }}</v-card-title>

                      <p class="pa-3 body-1 text-justify">
                        {{ card.description }}
                      </p>
                    </v-card>
                  </div>
                </div>
              </v-col>
              <!-- End card loop -->
            </v-row>
          </v-container>
        </v-card>
      </v-container>

      <!-- end 3rd section -->
      <!-- start  6th section -->

      <v-container fluid class="pa-0 mb-2">
        <div>
          <v-row no-gutters>
            <v-col cols="12">
              <v-img class="white--text" height="630px" src="@/assets/homebg6.jpg">
                <v-container>
                  <div>
                    <v-row no-gutters justify="center">
                      <v-col cols="12" class="d-flex justify-center">
                        <v-card class="ma-2" elevation="2">
                          <v-card-text class="text-center mx-auto">
                            <h1 class="linespht white--text fd50">
                              Our Prestige Clients
                            </h1>
                            <h3 class="linespht white--text">
                              Sactin has been a trustworthy technology partner and being
                              the right choice for every type of school.
                            </h3>
                          </v-card-text>
                          <!-- start slider -->

                          <v-container class="mt-16 pt-6">
                            <v-slide-group
                              show-arrows
                              class="d-flex justify-center"
                              center-active
                              v-model="selected"
                            >
                              <v-slide-item
                                v-for="(card, index) in schoolname"
                                :key="index"
                                v-slot="{ active, toggle }"
                              >
                                <v-card
                                  class="text-center"
                                  @click="toggle"
                                  :elevation="active ? 12 : 2"
                                >
                                  <v-img
                                    :src="require(`@/assets/logo/${card.image}`)"
                                    class="brradius mx-auto"
                                    style="
                                      width: 150px;
                                      height: 150px;
                                      /* background: white; */
                                    "
                                  ></v-img>

                                  <p
                                    class="pa-3 text-center d-flex justify-center"
                                    v-html="card.title"
                                  ></p>
                                </v-card>
                              </v-slide-item>
                            </v-slide-group>
                          </v-container>

                          <!-- end slider -->
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-container>

                <!-- stop -->
              </v-img>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <!-- end 6th section -->

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-5"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Sactin Interactive Panels
                      </h1>
                      <p class="text-justify body-1">65" Sactin Interactive Panel</p>
                      <p class="text-justify body-1">75" Sactin Interactive Panel</p>
                      <p class="text-justify body-1">85" Sactin Interactive Panel</p>
                      <p class="text-justify body-1">98" Sactin Interactive Panel</p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <!-- start footer -->
      <WebsiteFooter />
      <!-- end footer -->
    </v-app>
  </v-container>
</template>

<script>
import WebsiteFooter from "../WebsitePages/WebsiteFooter.vue";
export default {
  components: {
    WebsiteFooter,
  },
  data() {
    return {
      observer: null,
      cards: [
        {
          title: "Sactin Mobile App",
          description: "An Excellent mobile application for all the needs of school.",
          image: "Sactin Mobile App.png",
        },
        {
          title: "Sactin Library",
          description: "Online library that allows Students to move upgraded.",
          image: "Sactin Library.png",
        },
        {
          title: "Sactin GPS Tracking",
          description: "The GPS tracking allows a close watch on where the bus is.",
          image: "sactin gps tracking.png",
        },
        {
          title: "Sactin ERP",
          description: "An Excellent mobile application for all the needs of school.",
          image: "ERP.jpg",
        },
      ],
      schoolname: [
        {
          title: `<div>  Floreate International <br/> Malapuram  </div>`,
          image: "Group 617.png",
        },
        {
          title: `<div> Bappuji Central School <br/> Peruva  </div>`,
          image: "Group 623.png",
        },

        {
          title: `<div>St Alphonsa Public School  <br/> Mini-Ooty Oorakam  </div>`,
          image: "Group 619.png",
        },
        {
          title: `<div> Vimala  Public School <br/> Thodupuzha </div>`,
          image: "Group 629.png",
        },
        {
          title: `<div> St Antony's  Public School <br/> Kizhakkambalam  </div>`,
          image: "Group 630.png",
        },
        {
          title: `<div> Nirmal Hrudaya E.M.School <br/> Calicut, Mankav  </div>`,
          image: "Group 631.png",
        },
        {
          title: `<div> De Paul  Public School <br/> & Junior College  </div>`,
          image: "Group 511.png",
        },
        {
          title: `<div>Infant Jesus Public School  <br/> Kanjirapally  </div>`,
          image: "Group 514.png",
        },
        {
          title: `<div> Little Flower Vidyanikethan <br/> Monippally  </div>`,
          image: "Group 515.png",
        },
        {
          title: `<div> Bappuji English Medium <br/> School  Koothattukulam  </div>`,
          image: "Group 518.png",
        },
        {
          title: `<div> Bee Line Public School </div>`,
          image: "Group 537.png",
        },
        {
          title: `<div> Al Farook Residential  <br/>  School Calicut, Farook </div>`,
          image: "Group 542.png",
        },
        {
          title: `<div> Chinmaya Vidyalaya <br/> Kozhikode </div>`,
          image: "Group 557.png",
        },
        {
          title: `<div> Caliph Life School </div>`,
          image: "Group 558.png",
        },
        {
          title: `<div> ABC Montessori <br/> International School </div>`,
          image: "Group 559.png",
        },
        {
          title: `<div> Noorul Huda English  <br/> School Lucknow  </div>`,
          image: "Group 560.png",
        },
        {
          title: `<div> PEMS CBSE <br/> Parappanangadi  </div>`,
          image: "Group 561.png",
        },

        {
          title: `<div> Bharatiya Vidhya Bhavan <br/> Koilandy Kendra </div>`,
          image: "Group 563.png",
        },
        {
          title: `<div> Stella Maris <br/> Convent School </div>`,
          image: "Group 571.png",
        },
        {
          title: `<div> St Joseph Public School <br/> Kunnumbhagam  </div>`,
          image: "Group 573.png",
        },
        {
          title: `<div>Nirmala Public School <br/> Karimanoor </div>`,
          image: "Group 579.png",
        },

        {
          title: `<div> Fatima Central School <br/> Piravom </div>`,
          image: "Group 584.png",
        },
        {
          title: `<div> Shanthal Jyothi Public  <br/> School Muttom </div>`,
          image: "Group 587.png",
        },
        {
          title: `<div>Noble Public School <br/> Manjeri </div>`,
          image: "Group 592.png",
        },
        {
          title: `<div> Nest Public School  </div>`,
          image: "Group 593.png",
        },
        {
          title: `<div> Mother School,  Kannur </div>`,
          image: "Group 595.png",
        },
        {
          title: `<div> De Paul H.S.S <br/> kuravillangadu </div>`,
          image: "Group 605.png",
        },
        {
          title: `<div>St.Paul's Bethany School <br/>Kolenchery</div>`,
          image: "Group 615.png",
        },
        {
          title: `<div> Grace Valley Public <br/> School, Malapuram </div>`,
          image: "Group 616.png",
        },

        {
          title: `<div>St Paul's High School <br/> Thenhipalam  </div>`,
          image: "Group 618.png",
        },

        {
          title: `<div> Mahlara Public School <br/> Mavoor,Calicut  </div>`,
          image: "Group 620.png",
        },
        {
          title: `<div> Straightpath International <br/> Panakkad, Malappuram </div>`,
          image: "Group 621.png",
        },

        {
          title: `<div> St Xaviours Public <br/> School, Pothanicadu  </div>`,
          image: "Group 624.png",
        },
        {
          title: `<div> Lisieux English S.S <br/> School, Pothanicadu </div>`,
          image: "Group 625.png",
        },

        {
          title: `<div> Darul Hasanath English<br/>  School </div>`,
          image: "Group 626.png",
        },
        {
          title: `<div> KET Public School <br/> Kuttiyadi,Calicut  </div>`,
          image: "Group 627.png",
        },
      ],
    };
  },
  methods: {
    getImage(imageName) {
      return require(`@/assets/${imageName}`);
    },
  },
  mounted() {
    const observer1 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer1.unobserve(entry.target); // run only once
          }
        });
      },
      { threshold: 0.2 } // trigger when 20% visible
    );

    document.querySelectorAll(".process-circle").forEach((el) => {
      observer1.observe(el);
    });
    const options = {
      root: null,
      rootMargin: "0px 0px -10% 0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const anim = entry.target.querySelector(".anim-item");
        if (!anim) return;

        if (entry.isIntersecting) {
          anim.classList.add("in-view"); // play animation
        } else {
          anim.classList.remove("in-view"); // reset when out of view
        }
      });
    }, options);

    [
      "leftHeadingMobile",
      "imageCard1",
      "imageCard2",
      "rightHeadingDesktop",
      "paragraph",
    ].forEach((ref) => {
      const el = this.$refs[ref];
      if (el) observer.observe(el);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>

<style scoped>
::v-deep .theme--light.v-icon {
  color: white;
}
::v-deep .theme--light.v-sheet {
  background-color: transparent !important;
  border-color: transparent !important;
  color: white;
}
::v-deep .theme--dark.v-sheet {
  background-color: transparent;
  border-color: transparent;
  color: black;
}
::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.linespht {
  line-height: 1.5;
  letter-spacing: 2px;
}
.linespht1 {
  line-height: 1.5;
  letter-spacing: 1px;
}
@media screen and (min-width: 1100px) and (max-width: 1300px) {
  .htlargef {
    height: 90% !important;
  }
  .htlargeproductscn {
    height: 650px !important;
  }
  .htlargecertificatescn {
    height: 510px !important;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1670px) {
  .htlargef {
    height: 90% !important;
  }
  .fd50SS {
    font-size: 50px !important;
  }
  .htlargeproductscn {
    height: 650px !important;
  }
  .htlargecertificatescn {
    height: 510px !important;
  }
}
@media screen and (min-width: 1671px) {
  .htlargef {
    height: 70% !important;
  }
  .fd50SS {
    font-size: 60px !important;
  }
  .htlargeproductscn {
    height: 710px !important;
  }
  .htlargecertificatescn {
    height: 710px !important;
  }
}
.htlargef2 {
  height: 100% !important;
}
.clrblues {
  background-color: #04357e !important;
  color: white;
}
@media screen and (min-width: 700px) {
  .fd20 {
    font-size: 20px;
  }
  .fd50 {
    font-size: 40px;
    line-height: 1.5;
    letter-spacing: 2px;
  }
  .fd50SS {
    font-size: 50px;
  }
  .htlargeproductscn {
    height: 1115px;
  }
  .fd20ss {
    font-size: 30px !important;
  }
}

/* start card */
.a-box {
  display: inline-block;
  width: 100% !important;

  text-align: center;
}

.img-container {
  height: 120px;
  width: 200px;
  overflow: hidden;
  border-radius: 0px 0px 20px 20px;
  display: inline-block;
}

.text-container {
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2); */
  padding: 10px;
  border-radius: 20px;
  /* background: #e5e5e5; */
  background: white;
  margin: -120px 0px 0px 0px;
  line-height: 19px;
  font-size: 14px;
}

.text-container h3 {
  margin: 20px 0px 10px 0px;
  /* color: #04bcff; */
  font-size: 18px;
}
.brradius {
  border-radius: 12px !important;
}

/* start slider */
.v-slide-group__prev,
.v-slide-group__next {
  color: purple; /* Customize the arrow color */
}
/* end slider */

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}
.waviy .spans {
  /* font-family: 'Alfa Slab One', cursive; */
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-20px);
  }
}

/* end a1 */

/* a2 */

.contentan {
  position: relative;
}

.contentan h2 {
  color: #fff;
  font-size: 3em;
  position: absolute;
  transform: translate(-50%, -50%);
}

.contentan h2:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 2px #04357e;
  /* -webkit-text-stroke: 2px  #2A65BF; */
}

.contentan h2:nth-child(2) {
  color: #04357e;
  animation: animate 4s ease-in-out infinite;
}

@keyframes animate {
  0%,
  100% {
    clip-path: polygon(
      0% 45%,
      16% 44%,
      33% 50%,
      54% 60%,
      70% 61%,
      84% 59%,
      100% 52%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      15% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}
.letpx {
  left: 80px;
}
/* end a2 */
.clrbluetext {
  /* color: #04357e !important; */
  color: black;
}

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}

.waviy .spans {
  /* font-family: 'Alfa Slab One', cursive; */
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }

  20% {
    transform: translateY(-20px);
  }
}
.rainbow-text {
  background: linear-gradient(
    90deg,
    red,
    orange,
    yellow,
    green,
    blue,
    indigo,
    violet,
    red
  );
  background-size: 400% 400%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: rainbow-move 8s linear infinite;
}

@keyframes rainbow-move {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
/* end a1 */
.process-circle-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 3px solid #e29803;
  /* Vuetify primary color */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.process-circle-icon {
  font-size: 30px;
  margin-bottom: 10px;
}

.process-circle-num {
  position: absolute;
  bottom: -15px;
  background: #e29803;
  color: #fff;
  border-radius: 50%;
  padding: 5px 12px;
  font-weight: bold;
}
/* Shared hidden state */
.anim-item {
  opacity: 0;
  transition-property: opacity, transform;
  transition-duration: 800ms;
  transition-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);
}

/* When in-view */
.anim-item.in-view {
  opacity: 1;
  transform: translate(0, 0) scale(1);
}

/* Types */
.fade-up {
  transform: translateY(40px);
}
.fade-up.in-view {
  transform: translateY(0);
}

.fade-left {
  transform: translateX(40px);
}
.fade-left.in-view {
  transform: translateX(0);
}

.zoom-in {
  transform: scale(0.9);
}
.zoom-in.in-view {
  transform: scale(1);
}

/* Optional delay helpers */
.delay-100 {
  transition-delay: 0.1s;
}
.delay-150 {
  transition-delay: 0.15s;
}
.delay-200 {
  transition-delay: 0.2s;
}
.delay-300 {
  transition-delay: 0.3s;
}
@keyframes zoomInOut {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1); /* zoom in */
  }
  100% {
    transform: scale(1); /* back to normal */
  }
}

.zoom-effect {
  animation: zoomInOut 6s ease-in-out infinite; /* continuous zoom */
  transition: transform 0.3s ease-in-out;
}

.process-circle {
  position: relative;
  background: white;
  border-radius: 50%;
  padding: 30px;
  text-align: center;
  transition: all 0.4s ease; /* smooth animation */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg); /* zoom + tilt */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* stronger glow */
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 10px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg); /* spin icon */
}

.process-circle-text h3 {
  margin: 0;
  font-size: 18px;
  transition: color 0.3s ease;
}

.process-circle:hover .process-circle-text h3 {
  color: #e29803; /* change text color on hover */
}
.process-circle {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
}

.process-circle.visible {
  opacity: 1;
  transform: translateY(0);
}

.process-circle:nth-child(1) {
  transition-delay: 0.2s;
}
.process-circle:nth-child(2) {
  transition-delay: 0.4s;
}
.process-circle:nth-child(3) {
  transition-delay: 0.6s;
}
.process-circle:nth-child(4) {
  transition-delay: 0.8s;
}
.process-circle {
  width: 150px; /* fixed width */
  height: 150px; /* equal height */
  border-radius: 50%; /* make it a circle */
  background: white;
  display: flex;
  flex-direction: column; /* stack icon + text + number */
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto; /* center inside column */
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.4s ease;
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg);
}

.process-circle-num {
  position: absolute;
  bottom: -20px; /* place number outside circle */
  font-weight: bold;
  font-size: 18px;
  color: white;
}
@keyframes pulseLoop {
  0% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto;
  position: relative;
  cursor: pointer;

  /* 👇 add looping animation */
  animation: pulseLoop 3s ease-in-out infinite;
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle-num {
  position: absolute;
  bottom: -20px;
  font-weight: bold;
  font-size: 18px;
  color: white;
}
.fontfamMon {
  font-family: Montserrat !important;
}

/* start sssss */
/* start card */
.a-box {
  display: inline-block;
  width: 100% !important;

  text-align: center;
}

.img-container {
  height: 120px;
  width: 200px;
  overflow: hidden;
  border-radius: 0px 0px 20px 20px;
  display: inline-block;
}

.text-container {
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2); */
  padding: 10px;
  border-radius: 20px;
  background: #e5e5e5;
  margin: -120px 0px 0px 0px;
  line-height: 19px;
  font-size: 14px;
  /* height: 200px; */
  /* height: 260px; */
}

.text-container h3 {
  margin: 20px 0px 10px 0px;
  /* color: #04bcff; */
  font-size: 18px;
}

.brradius {
  border-radius: 12px !important;
}
</style>
